/**
 * A explicação longa de um cartão, recolhida.
 *
 * O que o cartão faz cabe numa linha; por que ele faz assim cabe num parágrafo, e é
 * leitura de primeira vez. Recolhido, o parágrafo continua a um clique de quem chega e
 * sai da frente de quem já sabe — que é quem abre esta tela todo dia.
 *
 * Mora em arquivo próprio porque as duas abas do quantitativo o usam: a montagem nos
 * cartões dela, e a aba de itens nos dela. Duas cópias divergiriam na primeira pressa.
 */
export function ComoFunciona({ children }: { children: React.ReactNode }) {
  return (
    <details className="text-xs text-(--color-content-muted) [&_strong]:font-medium [&_strong]:text-(--color-content)">
      <summary className="cursor-pointer select-none">Como funciona</summary>
      <p className="mt-1 max-w-prose">{children}</p>
    </details>
  );
}
